import React from "react";
import { motion } from "framer-motion";
import { images } from "../../constants";
import AppWrap from "../../wrapper/AppWrap";

const highlights = [
  { label: "Available for", value: "Freelance & collabs" },
  { label: "Location", value: "Kathmandu, Nepal / Remote" },
  { label: "Response time", value: "< 1 hour" },
];


const Header = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 opacity-40">
        <div className="absolute inset-0 bg-grid" />
      </div>

      <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="space-y-8"
        >

          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-white">
              Building calm, confident digital experiences.
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl">
              I help founders and product teams ship polished web and mobile products - fast. From product discovery to
              interaction details, I design and engineer experiences that feel effortless.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <a
              href="#work"
              className="px-5 py-3 rounded-full bg-gradient-to-r from-primary via-accent to-primaryDark text-white font-semibold shadow-glow hover:-translate-y-1 transition-transform"
            >
              View projects
            </a>
            <a
              href="mailto:com.nishanneupane@gmail.com"
              className="px-5 py-3 rounded-full border border-white/15 text-white hover:border-white/40 transition-colors"
            >
              Contact me
            </a>
            <div className="flex gap-2 text-sm text-slate-300">
              <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">Next.js</span>
              <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">Full-stack</span>
              <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">Mobile Development</span>
            </div>
          </div>


        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative"
        >
          <div className="absolute -inset-10 bg-gradient-to-br from-primary/25 via-accent/25 to-transparent blur-3xl rounded-[40px]" />
          <div className="relative rounded-[32px] overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl">
            <img
              src={images.banner}
              alt="Nishan Neupane"
              className="w-full h-[460px] object-cover"
            />

            <div className="absolute top-4 left-4 px-4 py-3 rounded-2xl bg-white/10 backdrop-blur border border-white/15 text-sm text-white">
              <p className="font-semibold">Nishan Neupane</p>
              <p className="text-slate-300 text-xs">Product-minded software engineer</p>
            </div>

            <div className="absolute bottom-4 right-4 flex flex-col gap-3 items-end">
              {highlights.map((item) => (
                <div
                  key={item.label}
                  className="px-4 py-2 rounded-xl bg-black/70 backdrop-blur border border-white/10 text-xs text-slate-200"
                >
                  <p className="text-[11px] uppercase tracking-[0.15em] text-slate-400">{item.label}</p>
                  <p className="font-semibold text-white">{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AppWrap(Header, "home");
